import React, { Fragment } from 'react'
import injectStyles from 'react-jss'
import ArrowRight from 'Components/Icons/ArrowRight'
import { Motion, spring } from 'react-motion'
import classNames from 'classnames'
import { useOnScrollHook } from 'Utils/Elements'

const closedX = 48
const openX = 226

const styles = {
  parentContainer: {
    position: 'relative',
  },
  container: {
    lineHeight: '48px',
    width: 220,
    position: 'absolute',
    top: 0,
    left: 0,
    minHeight: 200,
    zIndex: 1,
    color: '#8A96A0',
    fontSize: 14,
    backgroundColor: 'white',
    height: '100vh',
    '@global a': {
      color: 'inherit',
      fontSize: 14,
    },
  },
  contentWrapperExpanded: {
    paddingLeft: openX,
  },
  contentWrapperShrunk: {
    paddingLeft: closedX,
  },
  arrowContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
  },
  arrowInnerContainer: {
    position: 'absolute',
    top: '50%',
    right: 0,
    marginTop: -(12 + 5),
    opacity: 0.5,
    zIndex: 10,
    paddingTop: 10,
    width: 10,
    height: 24,
    cursor: 'pointer',
    paddingBottom: 10,
    boxSizing: 'content-box',
  },
  arrow: {
    position: 'relative',
    left: -7,
  },
}

const DashboardSidebar = ({ children, classes, open, onToggle, content }) => {
  var positionNav = () => {
    // If the marker goes below 0 we know we've scrolled it out of sight
    var { left } = this.parentContainer_.getBoundingClientRect()
    var { top } = this.marker_.getBoundingClientRect()
    if (top >= 0) {
      // Make the nav not fixed
      this.container_.style.position = 'absolute'
      this.container_.style.top = null
      this.container_.style.left = null
    } else {
      // Make the nav fixed
      this.container_.style.position = 'fixed'
      this.container_.style.top = 0
      this.container_.style.left = left + 'px'
    }
  }

  useOnScrollHook(positionNav)

  return (
    <div
      className={classes.parentContainer}
      ref={el => (this.parentContainer_ = el)}
    >
      <Motion
        defaultStyle={{ factor: open ? 0 : 1 }}
        style={{ factor: spring(open ? 0 : 1) }}
      >
        {({ factor }) => (
          <Fragment>
            <div ref={el => (this.marker_ = el)} />
            <div
              className={classes.container}
              style={{
                transform: `translate3d(-${(openX - closedX) *
                  factor}px, 0, 10px)`,
                paddingLeft: '30px',
              }}
              ref={el => (this.container_ = el)}
            >
              <div className={classes.arrowContainer} onMouseUp={onToggle}>
                <div className={classes.arrowInnerContainer}>
                  <ArrowRight
                    className={classes.arrow}
                    style={{
                      transform: `rotateY(${180 * (1 - factor)}deg)`,
                    }}
                  />
                </div>
              </div>
              <div>{children}</div>
            </div>
          </Fragment>
        )}
      </Motion>
      <div
        className={classNames({
          [classes.contentWrapper]: true,
          [classes.contentWrapperExpanded]: open,
          [classes.contentWrapperShrunk]: !open,
        })}
      >
        {content}
      </div>
    </div>
  )
}

export default injectStyles(styles)(DashboardSidebar)



// WEBPACK FOOTER //
// ./src/Components/DashboardSidebar/DashboardSidebar.js